import { DictionaryEntity } from '@app/pcs/models/dictionary-entity';

export enum CommonMandatoryParameterType {
  Mandatory = 'mandatory',
  MandatoryWhen = 'mandatoryWhen',
  MandatoryExcept = 'mandatoryExcept'
}

export interface ConditionImParameter {
  parameter: SingleSelectImParameter;
  value: string;
}

export interface CommonMandatoryParameter {
  parameterName: string;
  type: DictionaryEntity<CommonMandatoryParameterType>;
  conditionImParameter?: ConditionImParameter;
}

export interface SingleSelectImParameter {
  id: number;
  parameterName: string;
  typeInfo?: {
    values: string[];
  };
}
